/**
 * Created by RSchweber-Koren on 4/11/2017.
 */

import angular from "angular";
import Assert from "tbAssert";

import TrackingTargetFactoryModule from "./TrackingTargetFactory";

import ElectionCandidate from "../ElectionCandidate";

const mTrackingTargetFactory = new WeakMap();

class ElectionCandidateFactory {
    constructor(TrackingTargetFactory) {
        Assert.StrictAssert(TrackingTargetFactory != null, "Assertion Failure: Missing or Invalid Tracking Target Factory Service Dependency");
        mTrackingTargetFactory.set(this, TrackingTargetFactory);
    }

    Create(tTargetData, //object { isStub: T/F, data: (either a tracking target or a stub tracking target) }
           candidacyStart,
           candidacyEnd) {
        return new ElectionCandidate(tTargetData, candidacyStart, candidacyEnd, mTrackingTargetFactory.get(this));
    }

    CopyCandidate(srcCandidate) {
        Assert.StrictAssert(srcCandidate instanceof ElectionCandidate, "Assertion Failure: Copy Election Candidate source is not an ElectionCandidate");

        return new ElectionCandidate(
            { isStub: srcCandidate.candidateIsStub, data: srcCandidate.candidate },
            new Date(srcCandidate.candidacyStart.getTime()),
            new Date(srcCandidate.candidacyEnd.getTime(),
            mTrackingTargetFactory.get(this))
        );
    }

    FromServerElectionCandidate(serverCandidate) {

        const trackingTargetFactorySvc = mTrackingTargetFactory.get(this);

        let candidateObj = { isStub: true, data: { trackingTargetId: serverCandidate.CandidateId } };
        if (angular.isDefined(serverCandidate.Candidate)) {
            candidateObj.data = trackingTargetFactorySvc.FromServerTrackingTarget(
                serverCandidate.Candidate
            );
            candidateObj.isStub = false;
        }

        let serverCandidateStart = new Date(serverCandidate.CandidacyStartDate);
        let serverCandidateEnd = new Date(serverCandidate.CandidacyEndDate);

        return new ElectionCandidate(
            candidateObj,
            serverCandidateStart,
            serverCandidateEnd,
            trackingTargetFactorySvc
        );
    }

    addCandidateDataToCandidate(candidateToModify, targetData) {
        //Ensures targetData is a valid TrackingTarget
        let targetToAdd = mTrackingTargetFactory.get(this).CopyTarget(targetData);
        candidateToModify.addCandidateData(targetToAdd, true);
    }
}

ElectionCandidateFactory.$inject = [ "TrackingTargetFactory" ];

export default angular
    .module("trackerbase-app.models.factories.election-candidate-factory", [
        TrackingTargetFactoryModule
    ])
    .service("ElectionCandidateFactory", ElectionCandidateFactory)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/models/factories/ElectionCandidateFactory.js
// module id = HgoJ
// module chunks = 1